import paymentAPI from 'src/pages/deprecated/payment/api';

interface RedeemCampaignPayload {
  promoCode: string;
  priceId?: string;
  metadata?: Record<string, unknown>;
}

/**
 * Calls the campaign redemption API after a successful purchase.
 * Typically invoked from the success page when `campaignPurchased` is in the URL.
 */
export const redeemCampaign = async (
  payload: RedeemCampaignPayload
): Promise<void> => {
  await paymentAPI.post('/v1/promo-claims', {
    promoCode: payload.promoCode,
    priceId: payload.priceId,
    metadata: payload.metadata || {},
  });
};
